import { Box, Button, Card, Cell, Image, MarketingLayout, Page, Text } from "@wix/design-system";
import React, { useContext } from "react";
import wixLogo from "../../dashboard/images/wix-stores-logo.png";
import IconFaire from "../../dashboard/images/icon faire connect.svg";
import SiteContext from "../../contexts/site-context";

const StoreNotInstalledAlert = () => {
  const { siteId } = useContext(SiteContext);

  return (
    <Box align="center" verticalAlign="middle" marginTop={"30px"}>
      <Cell>
        <Card showShadow>
          <MarketingLayout
            title="We just encountered a bit of issue."
            description={
              <Text size="small">
                <ul>
                  <li>Make sure Wix Stores is installed to use our app.</li>
                  <li>If issues persist, try reinstalling the app to resolve them.</li>
                  <li>Still having trouble? Contact support via the "Contact Us" popup.</li>
                </ul>
              </Text>
            }
            size="tiny"
            hiddenBadge
            alignItems="stretch"
            image={
              <Box width="100%" align="right">
                <Image width="120px" src={IconFaire} transparent />
              </Box>
            }
          />
        </Card>
      </Cell>
    </Box>
  );
};
export default StoreNotInstalledAlert;
